import { Text, Accordion, Code, Box } from "@mantine/core";
import { EmailLog, ProcessStep } from "../../services/logService";
import { MasterStepDefinition } from "../../constants/stepDefinitions";
import { CsvPreview } from "./CsvPreview";
import { OcrResultStepContent } from "./OcrResultStepContent";
import { NormalizationSetupContent } from "./NormalizationSetupContent";
import { NormalizationResultContent } from "./NormalizationResultContent";
import { SlipDetectionContent } from "./SlipDetectionContent";
import { SlipResolutionContent } from "./SlipResolutionContent";
import { SlipConfigurationContent } from "./SlipConfigurationContent";

interface StepContentRendererProps {
  step: MasterStepDefinition;
  log: ProcessStep | null;
  logData: EmailLog;
}

/**
 * ステップごとの詳細コンテンツをレンダリング
 */
export function StepContentRenderer({ step, log, logData }: StepContentRendererProps) {
  if (!log) return null;

  // OCR完了ステップの場合
  if (step.id === "ocr_complete" && logData.ocrResult) {
    return <OcrResultStepContent logData={logData} log={log} />;
  }

  // CSV保存完了ステップの場合
  if (step.id === "csv_gen" && log.type === "csv_generated") {
    return <CsvPreview log={logData} />;
  }

  // 名寄せ設定読込ステップの場合
  if (step.id === "normalization_setup" && log.type === "normalization_setup") {
    return <NormalizationSetupContent log={log} />;
  }

  // 名称正規化ステップの場合
  if (step.id === "normalization" && log.type === "partner_normalization") {
    return <NormalizationResultContent log={log} />;
  }

  // 伝票種別判定ステップの場合
  if (step.id === "slip_type" && log.type === "slip_type_detection") {
    return <SlipDetectionContent log={log} />;
  }

  // 種別名寄せステップの場合
  if (step.id === "slip_type_resolution" && log.type === "slip_type_resolution") {
    return <SlipResolutionContent log={log} />;
  }

  // 種別設定解決ステップの場合
  if (step.id === "slip_type_config" && log.type === "slip_type_config_resolved") {
    return <SlipConfigurationContent log={log} />;
  }

  // デフォルト: 説明文と詳細表示
  return (
    <Box mt={4}>
      <Text
        size="xs"
        c={log.status === "error" ? "red" : "inherit"}
        style={{ whiteSpace: "pre-line" }}
      >
        {log.description}
      </Text>
      {log.details && Object.keys(log.details).length > 0 && (
        <Accordion
          variant="subtle"
          chevronPosition="right"
          styles={{
            item: { border: "none" },
            control: { padding: "0" },
            content: { padding: "8px 0" },
          }}
        >
          <Accordion.Item value="details">
            <Accordion.Control>
              <Text size="10px" c="blue" style={{ cursor: "pointer" }}>
                Rawデータを表示
              </Text>
            </Accordion.Control>
            <Accordion.Panel>
              <Code block style={{ fontSize: "10px", padding: "8px" }}>
                {JSON.stringify(log.details, null, 2)}
              </Code>
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
      )}
    </Box>
  );
}
